export const BUDGET_OPTIONS = ['installation', 'configuration', 'calibration', 'iqoq'];
export const CURRENCIES = ['CAD', 'USD', 'EUR'];
export const DISCOUNTABLE_LINES = ['gateway', 'installation', 'configuration', 'iqoq', 'travel', 'shipping'];
//# sourceMappingURL=types.js.map